import axios from '@fs/zion-axios'

const aamServiceBase = '/service/discovery/allaboutme'
const waifServiceBase = '/service/discovery/wicf'
const commonServiceBase = '/service/discovery/common'

export const getFamilyTreeData = async (generations = 8) => {
  return axios.get(`${aamServiceBase}/getFamily?generations=${generations}`)
}

export const getDetailedFamilyTreeData = async (generations = 8) => {
  return axios.get(`${waifServiceBase}/family?generations=${generations}`)
}

export const getPersonDetails = async ({ personId }) => {
  return axios.get(`/service/discovery/common/user/${personId}`)
}

export const getFamilyTreeDetails = async (generations = 8) => {
  return axios.get(`/service/discovery/wicf/family?generations=${generations}`)
}

export const getCampaigns = async (isMember = true) => {
  return axios.get('/service/campaign/sna/api/summary/userSummary', { params: { isMember } })
}

export const getMemories = async ({ personId }) => {
  return axios.get(`${commonServiceBase}/memory/person/${personId}?count=100`)
}

export const getTreeData = async ({ personId }) => {
  return axios.get(`/platform/tree/persons/${personId}`)
}
